<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>国旗管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <br />
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="国家名称">
            <el-input size="small" placeholder="请输入国家名称" clearable v-model="formInline.name"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="small" type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="small" type="primary" @click="handleEdit">新增</el-button>
        </el-form-item>
      </el-form>


      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="name" label="国家名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="国旗图片">
          <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 50px"
                :src=scope.row.imageOss
                :preview-src-list=[scope.row.imageOss]>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="updateDate" label="修改时间" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{scope.row.updateDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 编辑界面 -->
      <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
        <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
              <el-form-item label="国家名称" prop="name">
                <el-input size="small" v-model.trim="editForm.name" placeholder="请输入国家名称"></el-input>
              </el-form-item>
              <el-form-item label="国旗图片" prop="nationalOss">
                <el-upload
                  v-loading="uploading"
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :http-request="nationalUploadRequest"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="editForm.nationalOss" :src="editForm.nationalOss" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div slot="tip" class="el-upload__tip">参考地址：<a href="http://www.qiganshop.com" target="_blank">http://www.qiganshop.com</a></div>
               </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
              <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
          </div>
      </el-dialog>
    </div>
  </template>

  <script>
  import { getNationalList,addNational,editNational,delNational } from '../../api/basisMG'
  import {upimg} from '@/api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        uploading:false,
        editForm: {
          name:'',
          id:'',
          nationalOss:''
        },
        formInline: {
          page: 1,
          limit: 10,
        },
        rules:{
          name:[ { required: true, message: '请输入国家名称', trigger: 'blur' },]
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('只能上传jpg或png格式!');
        }
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
       //  国旗自定义上传（小）
    nationalUploadRequest(filePath){
      this.uploading = true
        let formData = new FormData()
        formData.append('file',filePath.file)
      upimg(formData).then(res=>{
        if(res.rsp_code==200){
          this.uploading = false
          this.editForm.imageNo = res.body.imageNo; //提交参数 图片标识串
          this.editForm.nationalOss = res.body.ossUrl; // 上传后回显
        }else{
          this.uploading = false
          this.$message.error('上传失败!');
        }
      })
    },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
         getNationalList(parameter).then(res => {
            this.loading = false
            if (res.rsp_code !== 200) {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
            } else {
              this.listData = res.body.records
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.body.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.name = row.name
          this.editForm.nationalOss = row.imageOss
          this.editForm.id = row.id
        } else {
          this.title = '添加'
          this.editForm = {
            name:'',
          id:'',
          nationalOss:''
          }
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let subType = this.title == '修改'?editNational:addNational
            let par = {
                imageNo:this.editForm.imageNo,
                name:this.editForm.name
            }
            let query = this.title == '修改'?this.editForm:par
            subType(query).then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.rsp_code==200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除公司
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delNational(row.id)
              .then(res => {
                if (res.rsp_code==200) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()
      },
      change(){
        this.$forceUpdate();  //强制刷新
      }
    }
  }
  </script>
 <style>
 .el-upload__tip{
   line-height: 20px;
 }
 .avatar-uploader .el-upload {
     border: 1px dashed #d9d9d9;
     border-radius: 6px;
     cursor: pointer;
     position: relative;
     overflow: hidden;
   }
   .avatar-uploader .el-upload:hover {
     border-color: #409EFF;
   }
   .avatar-uploader-icon {
     font-size: 28px;
     color: #8c939d;
     width: 100px;
     height: 100px;
     line-height: 100px;
     text-align: center;
   }
   .avatar {
     width: 100px;
     height: 100px;
     display: block;
   }
   .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
     width: 100px;
     height: 100px;
     line-height: 100px;
     text-align: center;
   }
 </style>
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>







// WEBPACK FOOTER //
// src/views/product/nationalFlag.vue